import React from "react";

export default () => (
  <div className="modal" id="termOfUseModal" data-toggle="modal">
   <div
    className="t-modalAreaTermOfUse"
    id="termOfUseModal"
   
  
  >
 <div className="t-modalContentTermOfUse" id="id-modalTipi"  data-toggle="modal" style={(window.innerWidth<=900)?{width:"89%"}: {width:"60%"}}>
    <div
      className="t-modalTermOfUse"
      id="id-modalGenel"
      style={{ backgroundColor: "#333", boxShadow:"0 6px 20px 0 rgba(0, 0, 0, 0.75)" }}
    >
      <div className="container-fluid">
        {/* Header */}
        <div className="row t-modalHeaderTermOfUse">
          <div
            className="col"
            id="id-modalHeader"
            style={{ color: "rgb(238, 238, 238)" }}
          >
            Kullanım Koşulları ve Gizlilik
          </div>
          <div className="col-auto t-cursorPointer" data-dismiss="modal">
            <i
              className="t-icon-cross"
              id="id-modalHeaderIcon"
              style={{ color: "rgb(238, 238, 238)" }}
            />
          </div>
        </div>
        {/* Body */}
        <div className="row t-modalBodyTermOfUse">
          <div
            className="col-12"
            id="id-modalBody"
            style={{ color: "rgb(238, 238, 238)" }}
          >
            <ol>
              <li>
                Bu web sitesine girmeniz veya bu web sitesindeki herhangi bir
                bilgiyi kullanmanız aşağıdaki koşulları ve hükümleri kabul
                ettiğiniz anlamına gelmektedir.
              </li>
              <li>
                Bu web sitesinin kullanımından doğan ve doğacak her türlü zarar
                ve/veya kayıplardan dolayı Emin Şirketler Grubu (bundan böyle
                kısaca `Eminevim` olarak anılacaktır), yönetim kurulu üyeleri,
                yöneticileri, çalışanları, bu sitede yer alan bilgileri
                hazırlayan kişilerin ve Eminevim`in yetkilendirdiği kişi ve
                kuruluşların hiçbir hukuki ve cezai sorumluluğu bulunmamaktadır.
              </li>
              <li>
                
                Eminevim bu yasal uyarıda yer alan tüm koşulları ve hükümleri
                önceden bir ihbara gerek kalmaksızın değiştirme ve güncelleme
                hakkını haizdir.
              </li>
              <li>
                Eminevim kullanıcılarının kişisel bilgilerinin gizliliğini
                korumaya özen gösterir.
              </li>
              <li>
                İşbu Gizlilik Politikası, https://www.eminevim.com/ sitesi ile
                ilgili hizmetleri sunarken, kişisel verilerinize ilişkin
                politikamızı içermektedir.
              </li>
              Bu gizlilik politikası kapsamında kural olarak kullanıcılarımız
              tarafından sitemize sunulan kişisel veriler (adınız, elektronik
              posta adresiniz, iş ve özel adresiniz, telefon numaralarınız vs)
              üçüncü kişilerle paylaşılmamakta, satılmamakta, kiralanmamakta ve
              başka şekilde kullandırılmamaktadır.Eminevim söz konusu kişisel
              verileri sadece; Kullanıcıların açık rızasına istinaden,
              Kullanıcılara katma değerli hizmetler, fırsat ve olanaklar
              sunulması ve hizmet kalitesinin artırılması amacıyla; grup
              şirketleri ile veya yasal bir zorunluluk gereği bu verileri talep
              etmeye yetkili olan kamu kurum veya kuruluşları ile
              paylaşabilecektir.Tüm korumalara rağmen Eminevim, kişisel
              bilgilerin sistemlerinden yasal olmayan yollarla elde
              edilemeyeceğini garanti edemez ve ayrıca Eminevim’in sistemlerinde
              güvenlik açığı riski de dahil olmak üzere ortaya çıkabilecek tüm
              riskleri ve sorumluluğu kabul etmiş sayılırsınız.
              <li>
                Bu web sitesinde yer alan, bunları içeren ama bunlarla sınırlı
                olmayan, tüm sayfalar, fotoğraflar, dizaynlar, resimler gibi
                malzemeler ve bilgilere ilişkin telif hakkı ve/veya diğer fikri
                mülkiyet hakları Eminevim’e ait ve ilgili kanunlarca korunmakta
                olup, bu malzemeler ve bilgiler izinsiz kullanılamaz, iktisap
                edilemez ve değiştirilemez.
              </li>
              <li>
                Kullanıcı veya Kullanıcılar, Web Sitesine girmeden önce yukarıda
                yer alan Web Sitesi Kullanım Koşulları ve Gizlilik Politikasını
                okuduklarını, yukarıda belirtilen tüm hususlara uyacaklarını,
                burada yer alan hususlarla ilgili olarak herhangi bir uyuşmazlık
                veya ihtilaf iddia veya talep olduğu takdirde, İstanbul Anadolu
                Mahkeme ve İcra Dairelerinin yetkili olacağını, Web Sitesinde
                yer alan içeriklerin ve Eminevim’e ait tüm elektronik ortam ve
                bilgisayar kayıtlarının HMK madde 193 uyarınca kesin delil
                sayılacağını gayrıkabili rücu olarak kabul, beyan ve taahhüt
                etmişlerdir.
              </li>
            </ol>
          </div>
        </div>
        {/* footer*/}
        <div className="row t-modalFooter">
          <div
            className="col-12"
            id="id-modalFooter"
            style={{ color: "rgb(238, 238, 238)" }}
          />
        </div>
      </div>
    </div>
  </div>

  </div>
  </div>
 
);
